var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_748_1278",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_748_1278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 20V12.4L8 7.4V9.65H6V4H11.65V6H9.4L14.425 11.025C14.6083 11.2083 14.75 11.4208 14.85 11.6625C14.95 11.9042 15 12.1583 15 12.425V20H13Z",
    fill: "#3A5F77"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg12);
export default __webpack_public_path__ + "static/media/12.663f54effb21186d74ccf42d0678e584.svg";
export { ForwardRef as ReactComponent };